export default "__VITE_ASSET__c61b8717__"